/* eslint-disable @typescript-eslint/no-explicit-any -- The typings should be improved for the EnvironmentContextType components  */
"use client";
// import utils
import { createContext } from "react";
export const EnvironmentContext = createContext({
    appName: "sdb",
    routePaths: {
        root: "/",
    },
    components: {
        Link: null,
        Image: null,
        Icon: null,
    },
    setUserId: () => null,
    setTenantId: () => null,
});
export const { Provider } = EnvironmentContext;
export default EnvironmentContext;
